import { FiberProvider } from "@-/com.npmjs.its-fine";
import { createElement, type PropsWithChildren, type ReactNode } from "react";
import { PortalContextBridgeScope } from "#portal-context-bridge-scope";
import type { PortalContextValues } from "#portal-context-bridge-scope-context";

/** Stable component type: context changes update providers without remounting content. */
export function PortalContextBridgeContent({
  children,
  values,
}: PropsWithChildren<{ values: PortalContextValues }>) {
  let content: ReactNode = children;
  for (const [context, value] of values.toReversed()) {
    content = createElement(context, { value }, content);
  }
  return (
    <FiberProvider>
      <PortalContextBridgeScope>{content}</PortalContextBridgeScope>
    </FiberProvider>
  );
}
